import React, { useEffect, useState } from 'react';


const slideshowImages = [
  "/images/location1.jpg",
  "/images/location2.jpg",
  "/images/location3.jpg",
  "/images/meals1.jpg",
  "/images/meals2.jpg",
  "/images/meals3.jpg",
  "/images/fitness1.jpg",
  "/images/fitness2.jpg",
  "/images/fitness3.jpg",
];

function Features() {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    document.title = 'Hotel Atlanta | Location and Amenities';
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % slideshowImages.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${slideshowImages[currentImage]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'background-image 1s ease-in-out',
        padding: '40px 20px',
        color: '#fff',
        minHeight: '100vh',
        backdropFilter: 'brightness(0.8)',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: 'auto', background: 'rgba(0,0,0,0.6)', padding: '30px', borderRadius: '10px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px' }}>Our Location & Amenities</h1>

        {/* Great Location */}
        <section style={{ marginBottom: '60px' }}>
          <h2>Great Location</h2>
          <p>
            Located in Sector 33 near DLF Phase 2 in Gurugram, with easy access to transportation and close to multinational companies like PWC and Zomato.
          </p>
          <div className="feature-images">
            {["location1", "location2", "location3"].map((img, i) => (
              <img
                key={i}
                src={`/images/${img}.jpg`}
                alt={`Location ${i + 1}`}
                className="hover-zoom"
              />
            ))}
          </div>
          <div style={{ marginTop: '30px' }}>
            <iframe
              title="Hotel Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.833879555008!2d77.071!3d28.610!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1e5b5b5b5b5b%3A0x5b5b5b5b5b5b5b5!2sDLF%20Phase%202%2C%20Gurgaon%2C%20India!5e0!3m2!1sen!2sin!4v1612345678901"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>

        {/* Free Meals */}
        <section style={{ marginBottom: '60px' }}>
          <h2>Free Meals</h2>
          <p>
            We offer a 24x7 food service with complimentary breakfast for all guests.
          </p>
          <div className="feature-images">
            {["meals1", "meals2", "meals3"].map((img, i) => (
              <img
                key={i}
                src={`/images/${img}.jpg`}
                alt={`Meal ${i + 1}`}
                className="hover-zoom"
              />
            ))}
          </div>
        </section>

        {/* Fitness Room */}
        <section>
          <h2>Fitness Room</h2>
          <p>
            Enjoy 24x7 gym access, sauna rooms, and professional massage services as part of your stay.
          </p>
          <div className="feature-images">
            {["fitness1", "fitness2", "fitness3"].map((img, i) => (
              <img
                key={i}
                src={`/images/${img}.jpg`}
                alt={`Fitness ${i + 1}`}
                className="hover-zoom"
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Features;